import {Component} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {BaseFeatureWelcomeComponent} from '@catapp/shared/feature/create-form-wizards/base-feature-welcome.component';
import {FeatureTypeService} from '@catmodules/core/services/index';
import {FeatureUnitsService} from '@catmodules/models/feature-units/services/feature-units.service';
import {UnitsService} from '@catmodules/models/units/services/units.service';
import {SelectItem} from 'primeng/primeng';
import {isNullOrUndefined} from 'util';

/**
 * A component to fast create a new FeatureUnit for the currently in use Feature
 *
 * A new FeatureUnit inherits the some properties of its linked Unit.
 *
 * This properties are:
 * - updateGroup
 */
@Component({
  templateUrl: './feature-units-welcome.component.html',
})
export class FeatureUnitsWelcomeComponent extends BaseFeatureWelcomeComponent {

  /**
   * The self-name to be used throughout the displayed elements.
   * Reference to the current used type of model
   * @type {string}
   */
  selfTitle = 'Feature Unit';

  /**
   * The title used by the form wizard component
   * @type {string}
   */
  title = `New ${this.selfTitle}`;

  /**
   * All potential linkable Unit items
   */
  units: SelectItem[];

  /**
   * A default value for a updateGroup if necessary
   * @type {number}
   */
  updateGroup = 0;

  /**
   * Label names to be used by form input elements.
   *
   * @type {{unit: string; isVirtual: string; updateGroup: string; buttons: {last: string}}}
   */
  labels = {
    unit: 'Unit',
    isVirtual: 'Is virtual',
    updateGroup: 'Update group',
    buttons: {
      last: `Save the ${this.selfTitle}`,
    },
  };

  /**
   * Returns true if the current form object is ready.
   * Ready means all necessary data that is required to display and use the form, is available
   * @returns {boolean}
   */
  get formIsReady() {
    let isReady = !isNullOrUndefined(this.getFeature());
    isReady = isReady && !isNullOrUndefined(this.updateGroup);
    isReady = isReady && !isNullOrUndefined(this.units);
    return isReady;
  }

  resetAfterComplete = true;

  constructor(private route: ActivatedRoute,
              private unitsService: UnitsService,
              private featureUnitsService: FeatureUnitsService,
              featureService: FeatureTypeService) {
    super(featureService);

    this.form = new FormGroup({
      unit: new FormControl('', [Validators.required]),
      isVirtual: new FormControl(false, []),
      updateGroup: new FormControl('', []),
    });

  }

  /**
   * Executes the request to create a new FeatureUnit
   *
   */
  /**
   * Creates a new entity
   *
   * The 'isVirtual' property needs to check explictly because it can still be NULL if the form was reset on one point
   */
  saveNewEntity() {

    const isVirtual = isNullOrUndefined(this.form.value.isVirtual) ? false : this.form.value.isVirtual;
    this.featureUnitsService
      .create({
        unit: this.form.value.unit,
        featureType: this.getFeature(),
        updateGroup: this.form.value.updateGroup,
        isVirtual,
      })
      .subscribe((featureUnit) => {
        this.setCurrentEntity(featureUnit);
        this.setIsCompleted(featureUnit !== null);
        this.getFeatureService().refreshCurrent();
      });
  }

  /**
   * Updates the current usable Unit items as soon as a new item list is available
   */
  beforeDisplayProperties(): void {
    this
      .unitsService
      .getAll()
      .subscribe((units: any[]) => {
        this.updateUnitsSelectItems(units);
      });
  }

  validatePropertiesView() {
  }

  unitSelected($event) {
    if (!isNullOrUndefined($event.value)) {
      this.form.patchValue({updateGroup: $event.value.update_group});
    }
  }

  private updateUnitsSelectItems(units) {
    this.units = [];
    units.forEach((item) => {
      let itemLabel = item.part_number + (item.description ? ' (' + item.description + ')' : '');
      this.units.push({label: itemLabel, value: item});
    });

    this.units.sort((p1, p2) => p1.label < p2.label ? -1 : 1);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/features/components/landing-pages/feature-units-welcome/feature-units-welcome.component.ts